<template>
  <router-view />
</template>

<script setup lang="ts">
// Main App component - renders router view
</script>
